import {injectable} from "inversify";
import {ENVIRONMENT} from "data/constants";

export type IGameInfoFragment = {
	data: {
		game: {
			locales: Array<string>;
			urls?: Array<{url: string; locale: string; path: string; local?: true}> | null;
		};
	};
};

export interface ILocalizationApiProvider {
	gameInfo: (_gameID: number) => Promise<IGameInfoFragment>;
}

@injectable()
export class LocalizationApiProvider implements ILocalizationApiProvider {
	gameInfo = async (_gameID: number) => {
		const result = (await import(`data/providers/api/locale_configs/${ENVIRONMENT}`)) as {
			default: IGameInfoFragment;
		};
		return result.default;
	};
}
